import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import { CATEGORY_INSERT_GQL } from '@/graphql/queries.gql';

export default {
  namespaced: true,
  state: {
    insertCategory: null,
  },
  mutations: {
    SET_CATEGORY_INSERT(state, payload) {
      state.insertCategory = payload;
    },
  },
  actions: {
    createCategory({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: CATEGORY_INSERT_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_CATEGORY_INSERT', data.createCategory);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
  },
  getters: {
    // Response variables which are used in view file as response to request
    insertCategory: state => state.insertCategory,
  },
};
